// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"6f94bd30","289":"900bee52","349":"db4f491c","453":"56109bf7","901":"c157e27b"}[chunkId] + ".chunk.js";
};